//
import Service from '@/services/api/service'
import ProviderModel from '@/models/Purchase/PchProvider'

/**
 * This class describes a pch provider.
 *
 * @class      PchProvider (name)
 */
export default class PchProvider extends Service {

  /**
   * Return the pch provider resource.
   *
   * @return     {Object}  The pch provider model
   */
  resource() {
    return ProviderModel
  }

  /**
   * Returns a pch provider list.
   *
   * @return     {Object}  The pch provider list request.
   */
  toList() {
    return this
      .append('branch_offices')
      .include('')
  }
}
